import { ReactNode } from 'react';

export default function PageLayout({ children }: { children: ReactNode }) {
  return (
    <main
      style={{
        width: '100%',
        maxWidth: 1200,
        margin: '0 auto',
        padding: '24px 16px calc(48px + env(safe-area-inset-bottom))',
      }}
    >
      {children}
    </main>
  );
}
